"use client";

import React from "react";
import { OspModal } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { DeleteTransactionModalProps } from "../types";
import Translations from "@translate/components/Portfolio/Transactions/DeleteTransactionModal/DeleteTransactionModal";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export const DeleteTransactionModal: React.FC<DeleteTransactionModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}) => {
  return (
    <OspModal
      open={open}
      onCancel={onClose}
      centered
      footer={null}
      title={null}
      closable={!loading}
      maskClosable={!loading}
      styles={{
        content: {
          width: 360,
          padding: 0,
          background: "transparent",
        },
        body: {
          padding: 0,
        },
      }}
    >
      <div className="flex w-full flex-col gap-6 rounded-2xl bg-background_solid_secondary px-6 pb-3 pt-6">
        <div className="flex flex-col items-start gap-2">
          <h2
            aria-label="Delete Transaction Modal h2"
            data-openreplay-label="Delete Transaction Modal h2 Semantic"
            id="sem-delete-transaction-modal-h2"
            className="headline_regular_s text-content_primary"
          >
            {I18n.t("Delete Transaction?")}
          </h2>
          <p className="body_m text-content_secondary">
            {I18n.t("Delete means delete, this asset won't come back.")}
          </p>
        </div>

        <div className="flex items-center justify-end gap-2">
          <button
            aria-label="Delete Transaction Modal"
            data-openreplay-label={`Delete Transaction Modal Button | ${I18n.t("Cancel")}`}
            id="btn-delete-transaction-modal"
            type="button"
            className={cn(
              "h-9 min-w-[80px] rounded-md border border-border_white_transparent20 px-3 body_bold_m text-content_primary transition focus:outline-none focus-visible:ring-2 focus-visible:ring-border_white_transparent20/60",
            )}
            onClick={onClose}
            disabled={loading}
          >
            {I18n.t("Cancel")}
          </button>
          <button
            aria-label="Delete Transaction Modal"
            data-openreplay-label={`Delete Transaction Modal Button | ${I18n.t("Confirm")}`}
            id="btn-delete-transaction-modal-2"
            type="button"
            className={cn(
              "h-9 min-w-[80px] rounded-md bg-background_white_overlay100 px-3 body_bold_m text-content_inverse_primary transition focus:outline-none focus-visible:ring-2 focus-visible:ring-background_white_overlay70",
              loading ? "opacity-60 cursor-not-allowed" : "",
            )}
            onClick={onConfirm}
            disabled={loading}
          >
            {I18n.t("Confirm")}
          </button>
        </div>
      </div>
    </OspModal>
  );
};
